var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChorme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0s12,5.4,12,12S18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11 s11-4.9,11-11S18.1,1,12,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,17c-0.8,0-1.7-0.2-2.5-0.7C7.1,15,6.3,11.9,7.7,9.5c1.4-2.4,4.4-3.2,6.8-1.8c2.4,1.4,3.2,4.4,1.8,6.8 C15.4,16.1,13.7,17,12,17z M12,8c-1.4,0-2.7,0.7-3.5,2c-1.1,1.9-0.4,4.4,1.5,5.5c1.9,1.1,4.4,0.4,5.5-1.5c1.1-1.9,0.4-4.4-1.5-5.5 C13.4,8.2,12.7,8,12,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,8H12c-0.3,0-0.5-0.2-0.5-0.5S11.7,7,12,7h10.5C22.8,7,23,7.2,23,7.5S22.8,8,22.5,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,14.8c-0.2,0-0.3-0.1-0.4-0.2L2.6,5.8C2.4,5.5,2.5,5.2,2.7,5.1C3,4.9,3.3,5,3.4,5.2L8.5,14 c0.1,0.2,0.1,0.5-0.2,0.7C8.3,14.7,8.2,14.8,8.1,14.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,23.5c-0.1,0-0.2,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l4.9-8.8c0.1-0.2,0.4-0.3,0.7-0.2 c0.2,0.1,0.3,0.4,0.2,0.7l-4.9,8.7C11.3,23.4,11.2,23.5,11,23.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChorme);
export default __webpack_public_path__ + "static/media/chorme.1a60694b.svg";
export { ForwardRef as ReactComponent };